import { useCallback } from "react";
import useSWR from "swr";
import Auth from "../Auth";

const USER_METADATA_FETCH_OPTIONS = {
  requestSource: "user-metadata-swr",
  responseReadFailureRetries: 2,
  responseReadFailureRetryDelayMs: 250,
};

const useUserMetadata = () => {
  const fetcher = (url) =>
    Auth.fetchWithIdToken(url, {}, null, USER_METADATA_FETCH_OPTIONS);

  const endpointURL = "/api/user-metadata/get";
  const {
    data,
    error,
    isLoading,
    isValidating,
    mutate,
  } = useSWR(endpointURL, fetcher, {
    revalidateIfStale: false,
    revalidateOnFocus: false,
  });

  // Keep the existing refetch return value for callers of this hook.
  const refetch = useCallback(async () => (await mutate())?.userMetadata, [mutate]);

  return {
    userMetadata: data?.userMetadata,
    isLegacyProjectFlowTreatment: data?.isLegacyProjectFlowTreatment,
    refetch,
    error,
    isLoading,
    isValidating,
  };
};

export default useUserMetadata;
